// Staffelpreis-Fortschrittsleiste — reine Logik + Web-Component.
// Wird als ES-Modul geladen; die Logik ist DOM-frei und damit testbar.

export function computeStaffelState(tiers, quantity) {
  const sorted = (tiers || [])
    .map((t) => ({ min: parseInt(t.min_quantity, 10), price: parseFloat(t.unit_price) }))
    .filter((t) => !Number.isNaN(t.min) && !Number.isNaN(t.price))
    .sort((a, b) => a.min - b.min);

  if (sorted.length === 0) {
    return { atTop: true, remaining: 0, nextUnitPrice: null, savingsPerBox: 0, fillPercent: 100 };
  }

  const qty = Math.max(parseInt(quantity, 10) || 0, 0);

  // Aktive Stufe: höchste mit min <= qty (Fallback: erste Stufe).
  let active = sorted[0];
  for (const t of sorted) {
    if (t.min <= qty) active = t;
    else break;
  }

  // Nächste Stufe: erste mit min > qty.
  const next = sorted.find((t) => t.min > qty) || null;

  if (!next) {
    return { atTop: true, remaining: 0, nextUnitPrice: null, savingsPerBox: 0, fillPercent: 100 };
  }

  const remaining = next.min - qty;
  const savingsPerBox = Math.max(active.price - next.price, 0);
  const span = next.min - active.min;
  const progressed = qty - active.min;
  let fillPercent = span > 0 ? (progressed / span) * 100 : 0;
  fillPercent = Math.min(Math.max(fillPercent, 0), 100);

  return { atTop: false, remaining, nextUnitPrice: next.price, savingsPerBox, fillPercent };
}

// Web-Component nur im Browser definieren (Guard hält das Modul Node-testbar).
if (typeof HTMLElement !== 'undefined' && typeof customElements !== 'undefined') {
  class StaffelpreisGoal extends HTMLElement {
    connectedCallback() {
      try {
        this.tiers = JSON.parse(this.dataset.tiers || '[]');
      } catch (e) {
        this.tiers = [];
      }
      this.currency = this.dataset.currency || 'EUR';
      this.formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      this.label = this.querySelector('[data-staffel-label]');
      this.bar = this.querySelector('[data-staffel-bar]');
      this.input = this.closest('.product-form')?.querySelector('input[name="quantity"]');

      if (this.tiers.length < 2 || !this.input) {
        this.hidden = true;
        return;
      }

      this.onChange = this.update.bind(this);
      this.input.addEventListener('change', this.onChange);
      this.input.addEventListener('input', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      if (!this.input) return;
      this.input.removeEventListener('change', this.onChange);
      this.input.removeEventListener('input', this.onChange);
    }

    update() {
      const qty = parseInt(this.input.value, 10) || 0;
      const state = computeStaffelState(this.tiers, qty);

      if (this.bar) {
        this.bar.style.setProperty('--percent', `${state.fillPercent}%`);
      }

      if (!this.label) return;

      if (state.atTop) {
        this.label.textContent = '✓ Bester Preis erreicht';
        return;
      }

      const saving = this.formatter.format(state.savingsPerBox);
      this.label.textContent =
        `Noch ${state.remaining} Stück um ${saving} zu sparen`;
    }
  }

  if (!customElements.get('staffelpreis-goal')) {
    customElements.define('staffelpreis-goal', StaffelpreisGoal);
  }
}
